import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import ListaZo from '../../../components/funcionales/dirmayor/listazo';
import ListaBa from '../../../components/funcionales/dirmayor/listaba';
import selDirmayor from '../../../functions/seldirmayor';

//utils
import queries from '../../../utils/queries'

import SeguroPermite from '../../../components/funcionales/seguropermite'

// "use strict";

// //dropdown TARIFAS
// const DetalleSelTar = props => {
//   return (
//     <option dato1={props.elemento._id} value={props.elemento.codigoTarifa}>{props.elemento.codigoTarifa} ={">"} {props.elemento.descrTarifa}</option>
//   )
// };

// //Tarifa actual
// const ListaTar = ({styles, list, handleChange}) => {
//   const detalleTar = list.map((elemento, _id) => <DetalleSelTar styles={styles} elemento={elemento} key={elemento._id} />);
//   return(
//     <div>
//       <select style={styles.input} className="ui simple selection dropdown fluid" name="tarifa" id="tarifa" onChange={(ev)=>handleChange(ev)}>
//         <option value="">Todas...</option>
//         {detalleTar}
//       </select>
//     </div>
//   )
// };
// //Fin dropdown TARIFAS

//dropdown TARIFAS
const DetalleSelTar = props => {
  return (
    <option dato1={props.elemento.cicloFact} value={props.elemento.codigoTarifa}>{props.elemento.codigoTarifa} ={">"} {props.elemento.descrTarifa}</option>
  )
};

//Tarifa actual
const ListaTarA = ({styles, list, handleChange}) => {
  const detalleTar = list.map((elemento, _id) => <DetalleSelTar styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tarifaA" id="tarifaA" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {detalleTar}
      </select>
    </div>
  )
};

//Tarifa nueva
const ListaTarN = ({styles, list, handleChange}) => {
  const detalleTar = list.map((elemento, _id) => <DetalleSelTar styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tarifaN" id="tarifaN" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {detalleTar}
      </select>
    </div>
  )
};
//Fin dropdown TARIFAS

//dropdown SERVICIOS
const DetalleSelServ = props => {
  return (
    <option dato1={props.elemento._id} value={props.elemento.codigoServicio}>{props.elemento.codigoServicio} ={">"} {props.elemento.descripcionServicio}</option>
  )
};

//Servicio actual
const ListaServA = ({styles, list, handleChange}) => {
  const detalleTar = list.map((elemento, _id) => <DetalleSelServ styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="servicioA" id="servicioA" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {detalleTar}
      </select>
    </div>
  )
};

//Servicio nuevo
const ListaServN = ({styles, list, handleChange}) => {
  const detalleTar = list.map((elemento, _id) => <DetalleSelServ styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="servicioN" id="servicioN" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {detalleTar}
      </select>
    </div>
  )
};
//Fin dropdown SERVICIOS
//dropdown ESTRATOS
const DetalleNivelES = props => {
  return (
    <option value={props.elemento.descrEstrato}>{props.elemento.descrEstrato}</option>
  )
};

const ListaES = ({styles, list, handleChange}) => {
  const NivelDetalleES = list.map((elemento, _id) => <DetalleNivelES styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEstrato" id="miListaE" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {NivelDetalleES}
      </select>
    </div>
  )
};//Fin dropdown ESTRATOS
//Lista de clientes a los que se les va a actualizar la servicio
const ActTar = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.contrato}</td>
      <td className='right aligned'>{elemento.valorServiciosTA}</td>
      <td className='right aligned'>{elemento.valorAntesImptosTA}</td>
      <td className='right aligned'>{elemento.valorServicios}</td>
      <td className='right aligned'>{elemento.valorAntesImptos}</td>
    </tr>
  )
};

const ListaAT = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <ActTar elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const argsBuscarCL = {numDocum: 1}

class ProcCS2 extends React.Component {
  state={argsDocum: {codigoTarifaA: "Seleccionar...", codigoTarifaN: "Seleccionar...",
        cicloFactA: "", cicloFactN: "", codigoServicioA: "Seleccionar...", codigoServicioN: "Seleccionar...",
        descrEstrato: "Seleccionar...", descrDpto: "Todos...", nombreCiudad: "Todas...",
        nombreZona: "Todas...", nombreBarrio: "Todos..."},
        creaColeccAct: [], creaColeccNOAct: [], creaColeccMas1Serv: [], creaColeccCSF: [],
        argsSelDpto: this.props.argsSelDpto, listaCliCS: [],
        actRenta: [], totCli: 0, checkCTS: false, checkCSF: true, fechaCSF: "", permiteUpdate: true,
        confirmaAct: false, open: false, errors: []}

  handleChange = (ev) => {
    let listaCliCS = [], creaColeccAct = [], creaColeccNOAct = [], creaColeccMas1Serv = [], creaColeccCSF = []
    this.setState({listaCliCS, creaColeccAct, creaColeccNOAct, creaColeccMas1Serv, creaColeccCSF})
    let argsDocum = this.state.argsDocum
    if(ev.target.name === "descrEstrato"){
      let miLista = document.getElementById("miListaE");
      if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
        argsDocum['descrEstrato'] = miLista.options[miLista.selectedIndex].value
      }else{
        argsDocum['descrEstrato'] = "Seleccionar..."
      }
    }else{
      if(ev.target.name === "servicioA"){
        let miLista = document.getElementById("servicioA");
        // miLista.options.selectedIndex = 0
        if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
          argsDocum['codigoServicioA'] = miLista.options[miLista.selectedIndex].value
        }else{
          argsDocum['codigoServicioA'] = "Seleccionar..."
        }
      }else{
        if(ev.target.name === "servicioN"){
          let miLista = document.getElementById("servicioN");
          // miLista.options.selectedIndex = 0
          if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
            argsDocum['codigoServicioN'] = miLista.options[miLista.selectedIndex].value
          }else{
            argsDocum['codigoServicioN'] = "Seleccionar..."
          }
        }else{
          if(ev.target.name === "tarifaA"){
            let miLista = document.getElementById("servicioA");
            miLista.options.selectedIndex = 0

            argsDocum['codigoServicioA'] = "Seleccionar..."
            miLista = document.getElementById("tarifaA");
            if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
              argsDocum['codigoTarifaA'] = miLista.options[miLista.selectedIndex].value
              argsDocum['cicloFactA'] = miLista.options[miLista.selectedIndex].attributes[0].value    
            }else{
              argsDocum['codigoTarifaA'] = "Seleccionar..."
              argsDocum['cicloFactA'] = ""
            }
          }else{
            if(ev.target.name === "tarifaN"){
              let miLista = document.getElementById("servicioN");
              miLista.options.selectedIndex = 0

              argsDocum['codigoServicioN'] = "Seleccionar..."
              miLista = document.getElementById("tarifaN");
              if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
                argsDocum['codigoTarifaN'] = miLista.options[miLista.selectedIndex].value
                argsDocum['cicloFactN'] = miLista.options[miLista.selectedIndex].attributes[0].value    
              }else{
                argsDocum['codigoTarifaN'] = "Seleccionar..."
                argsDocum['cicloFactN'] = ""
              }
            }else{
              if(ev.target.name === "checkCTS"){
                this.setState({checkCTS: ev.target.checked});
              }else{
                if(ev.target.name === "checkCSF"){
                  this.setState({checkCSF: ev.target.checked});
                }else{
                  const argsDocum = this.state.argsDocum
                  argsDocum[ev.target.name] = ev.target.value
                }
              }
            }
          }
        }
      }
    }
    // console.log(argsDocum)
    this.setState({argsDocum});
  }

  handleSubmit = async (ev)=>{
    // console.log(ev.target.name)
    let targetName = ev.target.name
    // if(ev.target.name==="pantalla"){
    //   console.log("click en pantalla")
    // }else{
    //   console.log("generar dx")
    // }
    //ACTUALIZAR BD
    async function crudBD(operacionCRUD, args, i) {
      console.log("CRUD")
        if(args.ctrlCampo === 'CRUD'){
      // console.log(i)
      // console.log(args)
          const {data} = await operacionCRUD({
            variables: args
          });
  
        //Se utiliza para traer el _id del documento creado
          if(args.ctrl_id === 'SI_ID'){
            if(Object.values(data)[0]._id){
              return Object.values(data)[0]._id
            }else{
              return 0
            }
          }
        }else{
          if(args.ctrlCampo === "MANY"){
            // console.log("MANY")
            // console.log(args)
            // const {data} = await operacionCRUD({
            await operacionCRUD({
              variables: args
            });
          }
        }
      }
  
      //ENVIO PARA ACTUALIZAR BD
      async function updColecc(crudColecc, argsCrud, totDocCRUD) {
      // console.log(argsCrud)
      // console.log(totDocCRUD)
        let codigo = 0
        // console.log(argsCrud)
        if(argsCrud[0].ctrl_id === 'SI_ID'){
          codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
        }else{
          await crudBD(crudColecc[0], argsCrud[0], 0)
        }
        if(codigo!==0){
          for(let i=1; i<totDocCRUD; i++){
            argsCrud[i]._id = codigo
          }
        }
      // console.log("inicio")
        for(let i=1; i<totDocCRUD; i++){
          await crudBD(crudColecc[i], argsCrud[i], i)
        }
        console.log("final")
      }

  if(targetName==="pantalla"){
    // let codProcDX = new Date().getTime();
    document.body.style.cursor = 'wait'
    let argsUpd
    let errors = []
    if(!this.props.allClientesRtes.allClientesRtes){
      errors.push({path: "Act Servicio", message: "Proceso de actualización de servicio a clientes, por favor espere un momento..."});
    }
    if(this.state.argsDocum.codigoTarifaA==="Seleccionar..."){
      errors.push({path: "Tarifa actual", message: "Debe seleccionar la tarifa actual"});
    }
    if(this.state.argsDocum.codigoTarifaN==="Seleccionar..."){
      errors.push({path: "Tarifa nueva", message: "Debe seleccionar la tarifa nueva"});
    }
    if(this.state.argsDocum.codigoServicioA==="Seleccionar..."){
      errors.push({path: "Servicio actual", message: "Debe seleccionar el servicio actual"});
    }
    if(this.state.argsDocum.codigoServicioN==="Seleccionar..."){
      errors.push({path: "Servicio nuevo", message: "Debe seleccionar el servicio nuevo"});
    }
    if(this.state.argsDocum.cicloFactA!==this.state.argsDocum.cicloFactN){
      errors.push({path: "Ciclo de facuración", message: `El ciclo de facturación de la tarifa actual (${this.state.argsDocum.cicloFactA}) debe ser igual al ciclo de facturación de la tarifa nueva (${this.state.argsDocum.cicloFactN})`});
    }

    // console.log(this.state.argsDocum)
    // console.log(this.state.argsSelDpto)
    this.setState({errors})
    if(errors.length===0){
      let clientesCS = [], argsBuscarCL = ""
      if(this.state.argsDocum.descrEstrato!=="Seleccionar..."){
        argsBuscarCL = `'descrEstrato': '${this.state.argsDocum.descrEstrato}'`
      }
      if(this.state.argsDocum.codigoTarifaA!=="Seleccionar..."){
        if(argsBuscarCL){argsBuscarCL += `, `}
        argsBuscarCL += `'tarifa.codigoTarifa': '${this.state.argsDocum.codigoTarifaA}'`
      }
      if(this.state.argsDocum.codigoServicioA!=="Seleccionar..."){
        if(argsBuscarCL){argsBuscarCL += `, `}
        argsBuscarCL += `'tarifa.servicios.codigoServicio': '${this.state.argsDocum.codigoServicioA}'`
      }

//Seleccionar clientes del dpto, ciudad, zona y barrio seleccionados
      if(this.state.argsSelDpto.descrDpto===undefined||this.state.argsSelDpto.descrDpto==="Todos..."){

      }else{
        if(this.state.argsSelDpto.nombreCiudad===undefined||this.state.argsSelDpto.nombreCiudad==="Todas..."){
          if(argsBuscarCL){argsBuscarCL += `, `}
          argsBuscarCL += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
        }else{
          if(this.state.argsSelDpto.nombreZona===undefined||this.state.argsSelDpto.nombreZona==="Todas..."){
            if(argsBuscarCL){argsBuscarCL += `, `}
            argsBuscarCL += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
            argsBuscarCL += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
          }else{
            if(this.state.argsSelDpto.nombreBarrio===undefined||this.state.argsSelDpto.nombreBarrio==="Todos..."){
              if(argsBuscarCL){argsBuscarCL += `, `}
              argsBuscarCL += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
              argsBuscarCL += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
              argsBuscarCL += `, 'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}'`
            }else{
              if(argsBuscarCL){argsBuscarCL += `, `}
              argsBuscarCL += `'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
              argsBuscarCL += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
              argsBuscarCL += `, 'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}'`
              argsBuscarCL += `, 'dirmayor.ciudades.zonas.barrios.nombreBarrio': '${this.state.argsSelDpto.nombreBarrio}'`
            }
          }
        }
      }

// console.log(argsBuscarCL)
      if(this.props.allClientesRtes.allClientesRtes){
        // console.log("filtrar")
        // let argsBuscarCL = `'contrato': {$ne: '${args.contrato}'}, numSorteos: '${args.numSorteos}'`
        argsBuscarCL = '{' + argsBuscarCL + '}'
        argsBuscarCL = {tipoqry: `[{$match: ${argsBuscarCL}}]`}
        // console.log(argsBuscarCL)
        let {data} = await this.props.allClientesRtes.refetch(argsBuscarCL)
        clientesCS = await data.allClientesRtes

        // let {data} = await this.props.allClientesRtes.refetch(argsBuscarCL)
        // clientesCS = await data.allClientesRtes
      }
      // if(this.state.argsDocum.codigoTarifaA!=="Todas..."){
        // clientesCS = clientesCS.filter(elemento => elemento.tarifa.codigoTarifa===this.state.argsDocum.codigoTarifaA)
      // }else{
      //   clientesCS = clientesCS.filter(elemento => elemento.estadoCliente!=="NUEVO")
      // }
      
      let list8 = this.props.allTarifa.allTarifa
      // console.log(clientesCS)
      // console.log(this.state.argsDocum)
      let listaCliCS = []
      let totCli = 0
      let creaColeccAct = [], creaColeccNOAct = [], creaColeccMas1Serv = [], creaColeccCSF = [], movColecc = [], actRenta = []
      let indexLis = list8.findIndex(tarifa => tarifa.codigoTarifa===this.state.argsDocum.codigoTarifaN);
      // console.log(indexLis)
      // console.log(list8[indexLis])
      let descrTarifaN = list8[indexLis].descrTarifa
      let serviciosN = list8[indexLis].servicios
      let numServiciosN = 0
      serviciosN.forEach(async (elementoA, _id) => {
        if(elementoA.codigoServicio===this.state.argsDocum.codigoServicioN){
          numServiciosN += 1
        }
      })
// console.log(numServiciosN)

      clientesCS.forEach((elemento, _id) => {
        let servColecc = []
        let servColeccCSF = []

        let cliCS = false, actTar = 0
        if(elemento.tarifa.codigoTarifa&&elemento.tarifa.codigoTarifa.servicios&&
            elemento.tarifa.codigoTarifa.servicios.length>1&&
            this.state.argsDocum.codigoTarifaA!==this.state.argsDocum.codigoTarifaN){
              // console.log("Mas de un servicio", elemento.contrato)
              actTar = 1
        }
        if(numServiciosN===0){
          // console.log("No existe servicio nuevo en tarifa nueva", elemento.contrato)
          actTar = 1
        }
        if(elemento.tarifa.codigoTarifa&&actTar!==1){
          // console.log(elemento.tarifa.codigoTarifa)
          // let indexLis = list8.findIndex(tarifa => tarifa.codigoTarifa===this.state.argsDocum.codigoTarifaN);
          // // console.log(indexLis)
          // // console.log(list8[indexLis])
          // let serviciosN = list8[indexLis].servicios

          // elemento.tarifa.servicios.forEach(async (elementoA, _id) => {
          //   if(elementoA.codigoServicio===this.state.argsDocum.codigoServicioA){
          //     actTar += 1
          //   }
          // })

          // serviciosN.forEach(async (elementoA, _id) => {
          //   if(elementoA.codigoServicio===this.state.argsDocum.codigoServicioA){
          //     actTar += 1
          //   }
          //   if(elementoA.codigoServicio===this.state.argsDocum.codigoServicioN){
          //     actTar += 1
          //   }
          // })

          // console.log(this.state.argsDocum, actTar, elemento.contrato)
          // if(actTar===3){
          if(actTar===0){
              // console.log(elemento.contrato, elemento.tarifa.codigoTarifa)
            let listServTar = serviciosN.map(servicio => ({...servicio}))
            let cargoMensual = 0
            let concepto = "", consecEnFra = 0
            elemento.tarifa.servicios.forEach(async (elemento2, _id) => {
              movColecc = []
              if(elemento2.codigoServicio===this.state.argsDocum.codigoServicioA){
                // if(elemento2.codigoServicio===this.state.argsDocum.codigoServicioN){
                  // console.log("11", elemento2.codigoServicio, this.state.argsDocum.codigoServicioA, this.state.argsDocum.codigoServicioN)
                indexLis = serviciosN.findIndex( servicio => servicio.codigoServicio === this.state.argsDocum.codigoServicioN );
                listServTar[indexLis].numeroServicios = elemento2.numeroServicios
                let valorS = null
                let servFinal = 0
                if(Number(elemento2.numeroServicios)>=Number(listServTar[indexLis].rango1NumServValorIni)){
                  if(Number(elemento2.numeroServicios)>Number(listServTar[indexLis].rango1NumServValorFin)){
                    valorS = listServTar[indexLis].rango1NumServValorFin * listServTar[indexLis].rango1Valor
                  }else{
                    valorS = elemento2.numeroServicios * listServTar[indexLis].rango1Valor
                  }
                  servFinal = listServTar[indexLis].rango1NumServValorFin
                }
                if(listServTar[indexLis].rango2NumServValorIni!==null&&Number(elemento2.numeroServicios)>=Number(listServTar[indexLis].rango2NumServValorIni)){
                  if(Number(elemento2.numeroServicios)>Number(listServTar[indexLis].rango2NumServValorFin)){
                    valorS += (listServTar[indexLis].rango2NumServValorFin - servFinal) * listServTar[indexLis].rango2Valor
                  }else{
                    valorS += (elemento2.numeroServicios - servFinal) * listServTar[indexLis].rango2Valor
                  }
                  servFinal = listServTar[indexLis].rango2NumServValorFin
                }
                if(listServTar[indexLis].rango3NumServValorIni!==null&&Number(ev.target.value)>=Number(listServTar[indexLis].rango3NumServValorIni)){
                  if(Number(elemento2.numeroServicios)>Number(listServTar[indexLis].rango3NumServValorFin)){
                    valorS += (listServTar[indexLis].rango3NumServValorFin - servFinal) * listServTar[indexLis].rango3Valor
                  }else{
                    valorS += (elemento2.numeroServicios - servFinal) * listServTar[indexLis].rango3Valor
                  }
                }
                if(valorS!==null&&valorS!==''){
                  let valorI = 0
                  listServTar[indexLis].imptos.forEach((elemento1, _id) => {
                    valorI += Math.round(valorS * (elemento1.porcImpto / 100))
                    movColecc.push({codigoImpto: elemento1.codigoImpto,
                      descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
                      valorImpto: Math.round(valorS * (elemento1.porcImpto / 100))})
                  })
                  valorS = (Math.round((valorS + valorI) / 10) * 10) - valorI
                  listServTar[indexLis].valorAntesImptos = valorS
                  valorS += valorI
                  // this.setState({movColecc});
                }
                listServTar[indexLis].valorServicios = valorS
                // listServTar[indexLis].imptos = movColecc
                argsUpd = {}
                argsUpd = {
                  "contrato": elemento.contrato,
                  "codigoTarifa": this.state.argsDocum.codigoTarifaN,
                  "descrTarifa": descrTarifaN,
                  //Valor servicios servicio nuevo
                  "valorServicios": listServTar[indexLis].valorServicios,
                  "valorAntesImptos": listServTar[indexLis].valorAntesImptos,
                  //Valor servicios servicio actual
                  "valorServiciosTA": elemento2.valorServicios,
                  "valorAntesImptosTA": elemento2.valorAntesImptos,
                }
                // console.log(argsUpd)
                // console.log(listServTar[indexLis])
                listaCliCS.push(argsUpd)
                cliCS = true

                argsUpd = {
                  "codigoServicio": listServTar[indexLis].codigoServicio,
                  "nombreResumido": listServTar[indexLis].nombreResumido,
                  "descripcionServicio": listServTar[indexLis].descripcionServicio,
  
                  "subclaseserv": {_id: listServTar[indexLis].subclaseserv._id,
                    codigoSubclaseServ: listServTar[indexLis].subclaseserv.codigoSubclaseServ,
                    descrSubclaseServ: listServTar[indexLis].subclaseserv.descrSubclaseServ,
                    claseserv: {_id: listServTar[indexLis].subclaseserv.claseserv._id,
                      codigoClaseServ: listServTar[indexLis].subclaseserv.claseserv.codigoClaseServ,
                      descrClaseServ: listServTar[indexLis].subclaseserv.claseserv.descrClaseServ
                    }},
                  "estadoServicio": elemento2.estadoServicio,
  
                  "rango1NumServValorIni": listServTar[indexLis].rango1NumServValorIni,
                  "rango1NumServValorFin": listServTar[indexLis].rango1NumServValorFin,
                  "rango1Valor": listServTar[indexLis].rango1Valor,
                  "rango2NumServValorIni": listServTar[indexLis].rango2NumServValorIni,
                  "rango2NumServValorFin": listServTar[indexLis].rango2NumServValorFin,
                  "rango2Valor": listServTar[indexLis].rango2Valor,
                  "rango3NumServValorIni": listServTar[indexLis].rango3NumServValorIni,
                  "rango3NumServValorFin": listServTar[indexLis].rango3NumServValorFin,
                  "rango3Valor": listServTar[indexLis].rango3Valor,
                  "numeroServicios": elemento2.numeroServicios,
                  "valorServicios": listServTar[indexLis].valorServicios,
                  "valorAntesImptos": listServTar[indexLis].valorAntesImptos,
                  "velEfecDownstream": listServTar[indexLis].velEfecDownstream,
                  "velEfecUpstream": listServTar[indexLis].velEfecUpstream,
                  "codigoTipoTec": listServTar[indexLis].codigoTipoTec,
                  "descrTipoTec": listServTar[indexLis].descrTipoTec,
                  "colorServicio": listServTar[indexLis].colorServicio,
                  "imptos": movColecc,                  
                }
                // console.log(argsUpd, listServTar[indexLis].estadoServicio, elemento2.estadoServicio, elemento.contrato)

                if(this.state.checkCSF===true){
                  if(this.props.allServicios.allServicios){
                    let listCSF = this.props.allServicios.allServicios
                    let indexLisCSF = -1
                      indexLisCSF = listCSF.findIndex( servicio => servicio.codigoServicio === listServTar[indexLis].codigoServicio );
                      concepto = listCSF[indexLisCSF].conceptoEnFra
                      consecEnFra = listCSF[indexLisCSF].consecEnFra
                  }
                  let argsUpdCSF = {
                    "estadoServicio": this.state.argsDocum.codigoServicioA,
                    "codigoServicio": listServTar[indexLis].codigoServicio,
                    "nombreResumido": listServTar[indexLis].nombreResumido,
                    "valorServicios": consecEnFra,
                    "descripcionServicio": listServTar[indexLis].descripcionServicio,
                    'velEfecDownstream': listServTar[indexLis].velEfecDownstream,
                    'velEfecUpstream': listServTar[indexLis].velEfecUpstream,
                    'codigoTipoTec': listServTar[indexLis].codigoTipoTec,
                    'descrTipoTec': listServTar[indexLis].descrTipoTec,
                    'colorServicio': listServTar[indexLis].colorServicio
                  }
                  servColeccCSF.push(argsUpdCSF)
                  // console.log(argsUpdCSF)
                }
                cargoMensual += argsUpd.valorServicios
                servColecc.push(argsUpd)
              }else{
                if(!this.state.checkCTS){
                  elemento2.imptos.forEach((elemento1, _id) => {
                    movColecc.push({codigoImpto: elemento1.codigoImpto,
                      descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
                      valorImpto: elemento1.valorImpto})
                  })

                  argsUpd = {
                    "codigoServicio": elemento2.codigoServicio,
                    "nombreResumido": elemento2.nombreResumido,
                    "descripcionServicio": elemento2.descripcionServicio,
    
                    "subclaseserv": {_id: elemento2.subclaseserv._id,
                      codigoSubclaseServ: elemento2.subclaseserv.codigoSubclaseServ,
                      descrSubclaseServ: elemento2.subclaseserv.descrSubclaseServ,
                      claseserv: {_id: elemento2.subclaseserv.claseserv._id,
                        codigoClaseServ: elemento2.subclaseserv.claseserv.codigoClaseServ,
                        descrClaseServ: elemento2.subclaseserv.claseserv.descrClaseServ
                      }},
                    "estadoServicio": elemento2.estadoServicio,
    
                    "rango1NumServValorIni": elemento2.rango1NumServValorIni,
                    "rango1NumServValorFin": elemento2.rango1NumServValorFin,
                    "rango1Valor": elemento2.rango1Valor,
                    "rango2NumServValorIni": elemento2.rango2NumServValorIni,
                    "rango2NumServValorFin": elemento2.rango2NumServValorFin,
                    "rango2Valor": elemento2.rango2Valor,
                    "rango3NumServValorIni": elemento2.rango3NumServValorIni,
                    "rango3NumServValorFin": elemento2.rango3NumServValorFin,
                    "rango3Valor": elemento2.rango3Valor,
                    "numeroServicios": elemento2.numeroServicios,
                    "valorServicios": elemento2.valorServicios,
                    "valorAntesImptos": elemento2.valorAntesImptos,
                    "velEfecDownstream": elemento2.velEfecDownstream,
                    "velEfecUpstream": elemento2.velEfecUpstream,
                    "codigoTipoTec": elemento2.codigoTipoTec,
                    "descrTipoTec": elemento2.descrTipoTec,
                    "colorServicio": elemento2.colorServicio,
                    "imptos": movColecc,
                    //Valor servicios servicio actual
                  }
                  console.log(argsUpd, elemento.contrato)
                  cargoMensual += argsUpd.valorServicios
                  servColecc.push(argsUpd)
                }
              }
            })
            if(cliCS){
              totCli += 1

              let argsAdd = {}
              argsAdd['tipoAct'] = "EditarTarifa"
              argsAdd['contrato'] = elemento.contrato
              argsAdd['tarifa'] = {codigoTarifa: this.state.argsDocum.codigoTarifaN,
                descrTarifa: descrTarifaN,
                fechaVence: elemento.tarifa.fechaVence,
                servicios: servColecc}

              if(servColecc.length===1){
                if(elemento.estadoCliente==="ACTIVO"){
                  creaColeccAct.push(argsAdd)
                }else{
                  creaColeccNOAct.push(argsAdd)
                }
              }else{
                creaColeccMas1Serv.push(argsAdd)
              }

              if(this.state.checkCSF===true){
                let argsAddCSF = {}
                argsAddCSF['tipoAct'] = "EditarTarifaCSF"
                argsAddCSF['contrato'] = elemento.contrato
                argsAddCSF['tarifa'] = {codigoTarifa: concepto,
                  servicios: servColeccCSF}
                creaColeccCSF.push(argsAddCSF)
              }
              // console.log(creaColeccCSF)
//Para actualizar la renta mensual
              argsUpd = {
                "tipoAct": "EditarCliOdeS",
                "_id": elemento._id,
                "estadoCliente": elemento.estadoCliente,
                "cargoMensual": cargoMensual,
                "saldoPendiente": elemento.saldoPendiente,
                // "cicloFact": cicloFact,
              }
              actRenta.push(argsUpd)
            }
          }
        }
      })
// console.log(creaColeccAct, creaColeccNOAct, creaColeccMas1Serv, creaColeccCSF)
// console.log(listaCliCS)
      this.setState({listaCliCS})
      this.setState({totCli})
      this.setState({creaColeccAct})
      this.setState({creaColeccNOAct})
      this.setState({creaColeccMas1Serv})
      this.setState({creaColeccCSF})
      this.setState({actRenta})

      clientesCS = []
      argsBuscarCL={}
      argsBuscarCL.numDocum = 1
      if(this.props.allClientesRtes.allClientesRtes){
        let {data} = await this.props.allClientesRtes.refetch(argsBuscarCL)
        clientesCS = await data.allClientesRtes
      }
    }
    document.body.style.cursor = 'default'
  }
    if(targetName==="excel"){
      var tableToExcel = (function() {
        var tmpElemento = document.createElement('a')
  //window.btoa => Encode a string in base-64
        var uri = 'data:application/vnd.ms-excel;base64,'
          , template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
                              xmlns:x="urn:schemas-microsoft-com:office:excel">
                          <head>
                            <!--[if gte mso 9]>
                              <xml><x:ExcelWorkbook>
                                    <x:ExcelWorksheets>
                                      <x:ExcelWorksheet>
                                        <x:Name>{worksheet}</x:Name>
                                        <x:WorksheetOptions><x:DisplayGridlines/>
                                        </x:WorksheetOptions>
                                      </x:ExcelWorksheet>
                                    </x:ExcelWorksheets>
                                  </x:ExcelWorkbook>
                              </xml>
                            <![endif]-->
                          </head>
                          <body><table>{table}</table></body>
                        </html>`
          , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
          , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
        return function(table, hoja) {
          if (!table.nodeType) table = document.getElementById(table)
          var ctx = {worksheet: hoja || 'Worksheet', table: table.innerHTML}
          tmpElemento.href = uri + base64(format(template, ctx))
          tmpElemento.download = 'acttar.xls';
          tmpElemento.click();
        }
      })()
  
      tableToExcel('tabla', 'acttar')
    }
    if(targetName!=="pantalla"&&targetName!=="excel"){
      //ACTUALIZAR TARIFA CON NUEVO SERVICIO
      document.body.style.cursor = 'wait'

      let errors = []
      if(this.state.creaColeccAct.length===0&&this.state.creaColeccNOAct.length===0&&this.state.creaColeccMas1Serv.length===0){
        errors.push({path: "Cambiar servicio", message: "No hay clientes seleccionados para cambiar el servicio"});
      }
      this.setState({errors})
      if(errors.length===0){
        let listaCliCS = this.state.listaCliCS
        // console.log(listaCliCS)
        let fechaHoy = new Date()
        let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
        fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
        
        let miLista = document.getElementById("servicioA");
        let descrServicioA = miLista.options[miLista.selectedIndex].text
        miLista = document.getElementById("servicioN");
        let descrServicioN = miLista.options[miLista.selectedIndex].text
        let detalle = `${descrServicioA} A ${descrServicioN}`
        if(descrServicioA===descrServicioN){
          detalle = `${descrServicioA}`
        }
        let creaHC = []
        listaCliCS.forEach((elemento1, _id) => {
          //CREA REGISTRO EN HISTCLIENTES
          let argsAddHC = {
            "fechaHistCliente": fechaHoy + ' ' + horaHoy,
            "contrato": elemento1.contrato,
            "movimiento": "Cambiar servicio",
            "descripcion": "Proceso masivo",
            "detalle": detalle,
            "usuarioCreate": sessionStorage.getItem('userLogin'),
          }
          creaHC.push(argsAddHC)
        })

        //Crear el registro en histclientes
        let creaHCMany = [], creaHCMany1 = []
        creaHC.forEach((elementoHC, ii) => {
          creaHCMany.push(elementoHC)
        })
        creaHCMany1.push({histcliente: creaHCMany})

        let numDocCRUD = 0
        let totDocCRUD = 1
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.createHistClienteMany)
        }

        argsCrud[numDocCRUD] = creaHCMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.createHistClienteMany

        // console.log(argsCrud)
        await updColecc(crudColecc, argsCrud, totDocCRUD)

        // console.log(this.state.creaColeccAct, this.state.creaColeccNOAct, this.state.creaColeccMas1Serv, this.state.creaColeccCSF)

        let actCliMany1 = []
        numDocCRUD = 0
        totDocCRUD = 1
        argsCrud = []
        crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editClienteUpdDocMany)
        }
        if(this.state.creaColeccAct.length>0){
          actCliMany1.push({cliente: this.state.creaColeccAct})
          // Actualiza el servicio de los clientes ACTIVO
          argsCrud[numDocCRUD] = actCliMany1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany
    
          // console.log(argsCrud)
          // console.log(totDocCRUD)
          await updColecc(crudColecc, argsCrud, totDocCRUD)
        }
        if(this.state.creaColeccNOAct.length>0){
          actCliMany1 = []
          actCliMany1.push({cliente: this.state.creaColeccNOAct})
          //Actualiza el servicio de los clientes NO ACTIVO
          argsCrud[numDocCRUD] = actCliMany1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany
    
          // console.log(argsCrud)
          // console.log(totDocCRUD)
          await updColecc(crudColecc, argsCrud, totDocCRUD)
        }
        if(this.state.creaColeccMas1Serv.length>0){
          actCliMany1 = []
          actCliMany1.push({cliente: this.state.creaColeccMas1Serv})
          //Actualiza el servicio de los clientes CON MAS DE UN SERVICIO
          argsCrud[numDocCRUD] = actCliMany1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany
    
          // console.log(argsCrud)
          // console.log(totDocCRUD)
          await updColecc(crudColecc, argsCrud, totDocCRUD)
        }
        
        let actCliManyCSF1 = []
        actCliManyCSF1.push({cliente: this.state.creaColeccCSF})
        numDocCRUD = 0
        totDocCRUD = 1
        argsCrud = []
        crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editClienteUpdDocMany)
        }

        argsCrud[numDocCRUD] = actCliManyCSF1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany

        // console.log(argsCrud)
        // console.log(totDocCRUD)
        await updColecc(crudColecc, argsCrud, totDocCRUD)

          //ACTUALIZAR RENTA MENSUAL EN clientes
        actCliMany1 = []
        actCliMany1.push({cliente: this.state.actRenta})

        numDocCRUD = 0
        totDocCRUD = 1
        argsCrud = []
        crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editClienteMany)
        }
        
        argsCrud[numDocCRUD] = actCliMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editClienteMany
            
        // console.log(argsCrud)
        // console.log(totDocCRUD)
        await updColecc(crudColecc, argsCrud, totDocCRUD)
        //FIN ACTUALIZAR RENTA MENSUAL EN clientes

        let creaColeccAct = [], creaColeccNOAct = [], creaColeccMas1Serv = [], creaColeccCSF = [], actRenta = []
        listaCliCS = []
        this.setState({listaCliCS, creaColeccAct, creaColeccNOAct, creaColeccMas1Serv, creaColeccCSF, actRenta})

        document.body.style.cursor = 'default'

        alert("!! Proceso finalizado !!")
      }
      document.body.style.cursor = 'default'
    }
    console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }
  
  async componentDidUpdate(prevProps){
    if(this.state.fechaCSF===""){
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let fechaCSF = fechaHoraHoy.substr(0, 7) + '-01'
      // let fechaCSF = "2023-05-01"
      this.setState({fechaCSF})
    }
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoZona!==undefined&&this.props.argsSelDpto.codigoZona!==""){
      let miLista = document.getElementById("miLista2");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoZona){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreZona'] = "Todas..."
        argsSelDpto['codigoZona'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoBarrio!==undefined&&this.props.argsSelDpto.codigoBarrio!==""){
      let miLista = document.getElementById("miLista3");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoBarrio){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreBarrio'] = "Todos..."
        argsSelDpto['codigoBarrio'] = ""
        argsSelDpto['codigoTipoDocT'] = ""
        argsSelDpto['numeroDocumT'] = ""
        argsSelDpto['descrRecursoT'] = ""
        argsSelDpto['codigoTipoDocR'] = ""
        argsSelDpto['numeroDocumR'] = ""
        argsSelDpto['descrRecursoR'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.descrDpto!==this.state.argsDocum.descrDpto||
        this.props.argsSelDpto.nombreCiudad!==this.state.argsDocum.nombreCiudad||
        this.props.argsSelDpto.nombreZona!==this.state.argsDocum.nombreZona||
        this.props.argsSelDpto.nombreBarrio!==this.state.argsDocum.nombreBarrio){
      const argsDocum = this.state.argsDocum
      argsDocum.descrDpto = this.props.argsSelDpto.descrDpto
      argsDocum.nombreCiudad = this.props.argsSelDpto.nombreCiudad
      argsDocum.nombreZona = this.props.argsSelDpto.nombreZona
      argsDocum.nombreBarrio = this.props.argsSelDpto.nombreBarrio
      this.setState({argsDocum});
      this.setState({argsSelDpto: this.props.argsSelDpto})
      let listaCliCS = [], creaColeccAct = [], creaColeccNOAct = [], creaColeccMas1Serv = [], creaColeccCSF = []
      this.setState({listaCliCS, creaColeccAct, creaColeccNOAct, creaColeccMas1Serv, creaColeccCSF})
      }

    // if(this.props.argsSelDpto!==prevProps.argsSelDpto){
    //   this.setState({argsSelDpto: this.props.argsSelDpto})
    // }
  }

  render(){
    const {argsDocum, listaCliCS, totCli, checkCTS, checkCSF, fechaCSF, permiteUpdate, confirmaAct, open, errors} = this.state;

    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selDirmayor(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let listZon = colecc.listZon
    let listBar = colecc.listBar

    let list6A = [], list6N = [], list7 = [], descrServicioA = "", descrServicioN = ""
    let descrTarifaA = "", descrTarifaN = ""
    // if(this.props.allTarifa.allTarifa){
    //   list7 = this.props.allTarifa.allTarifa
    // }
    if(this.props.allTarifa.allTarifa){
      list7 = this.props.allTarifa.allTarifa
      let indexLis = -1
      if(argsDocum.codigoTarifaA==="Seleccionar..."){
        descrTarifaA = "Tarifa actual"
      }else{
        indexLis = list7.findIndex( tarifaa => tarifaa.codigoTarifa === argsDocum.codigoTarifaA );
        descrTarifaA = list7[indexLis].descrTarifa
      }
      if(argsDocum.codigoTarifaN==="Seleccionar..."){
        descrTarifaN = "Tarifa nueva"
      }else{
        indexLis = list7.findIndex( tarifaa => tarifaa.codigoTarifa === argsDocum.codigoTarifaN );
        descrTarifaN = list7[indexLis].descrTarifa
      }
    }

    if(this.props.allTarifa.allTarifa){
      let indexLis = -1
      if(argsDocum.codigoTarifaA!=="Seleccionar..."){
        indexLis = list7.findIndex( tarifaa => tarifaa.codigoTarifa === argsDocum.codigoTarifaA );
        if(indexLis!==-1){
          list6A = list7[indexLis].servicios
          for(let i=0; i<list6A.length; i++){
            list6A[i]._id = i
          }
        }
      }
      // list6 = this.props.allServicios.allServicios
      // let indexLis = -1
      // console.log(argsDocum.codigoServicioA, argsDocum.codigoServicioN, list6A.length, list6A)
      if(argsDocum.codigoServicioA==="Seleccionar..."){
        descrServicioA = "Servicio actual"
      }else{
        indexLis = list6A.findIndex( tarifaa => tarifaa.codigoServicio === argsDocum.codigoServicioA );
        if(indexLis!==-1){
          descrServicioA = list6A[indexLis].descripcionServicio
        }
      }

      if(argsDocum.codigoTarifaN!=="Seleccionar..."){
        indexLis = list7.findIndex( tarifaa => tarifaa.codigoTarifa === argsDocum.codigoTarifaN );
        if(indexLis!==-1){
          list6N = list7[indexLis].servicios
          for(let i=0; i<list6N.length; i++){
            list6N[i]['_id'] = i
          }
        }
      }
      if(argsDocum.codigoServicioN==="Seleccionar..."){
        descrServicioN = "Servicio nuevo"
      }else{
        indexLis = list6N.findIndex( tarifaa => tarifaa.codigoServicio === argsDocum.codigoServicioN );
        if(indexLis!==-1){
          descrServicioN = list6N[indexLis].descripcionServicio
        }
      }
    }

    // if(this.props.allServicios.allServicios){
    //   list6 = this.props.allServicios.allServicios
    //   let indexLis = -1
    //   if(argsDocum.codigoServicioA==="Seleccionar..."){
    //     descrServicioA = "Servicio actual"
    //   }else{
    //     indexLis = list6.findIndex( tarifaa => tarifaa.codigoServicio === argsDocum.codigoServicioA );
    //     descrServicioA = list6[indexLis].descripcionServicio
    //   }
    //   if(argsDocum.codigoServicioN==="Seleccionar..."){
    //     descrServicioN = "Servicio nuevo"
    //   }else{
    //     indexLis = list6.findIndex( tarifaa => tarifaa.codigoServicio === argsDocum.codigoServicioN );
    //     descrServicioN = list6[indexLis].descripcionServicio
    //   }
    // }



    // console.log(checkCSF)
    // console.log(checkCTS)
    let mensaje = "CAMBIAR SERVICIOS"
    let imgIcon = "images/archivo_32.png"
    // console.log(this.props.allClientesRtes.allClientesRtes)
    // console.log(this.props.allTarifa.allTarifa)
    // console.log(this.props.list3)
    // console.log(this.state.argsSelDpto)
    // console.log(argsDocum)
  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
        <i className="large edit yellow icon"></i>
        Cambiar servicios
      </button>
      <div>
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev):()=>{}}>
            <div>
              <div className="ui two column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '57%'}}>
                    <h1 style={{color: '#2C7744'}}>Cambiar servicios a clientes</h1>
                    <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0em'}}>
                      Solo se cambiará el servicio si los dos servicios se encuentran en la misma tarifa o<br/>
                      si los servicios son de diferente tarifa, la tarifa actual del cliente solo debe tener el servicio a cambiar
                    </p>
                  </div>
                  <div className="column" style={{width: '43%'}}>
                    <Form.Field>
                    <h3 style={{color: '#302b63', marginTop: '2em'}}>
                        <input style={{margin: '0.2em 0em 0em 0em'}} type='checkbox' name="checkCTS" checked={checkCTS}  onChange={this.handleChange}/>
                        &nbsp;&nbsp;Cambiar todos los servicios del cliente por el Servicio nuevo
                      </h3>
                    </Form.Field>
                  </div>
                  {/* <div className="column" style={{width: '43%'}}>
                    <Form.Field>
                    <h3 style={{color: '#302b63', marginTop: '2em'}}>
                        <input style={{margin: '0.2em 0em 0em 0em'}} type='checkbox' name="checkCSF" checked={checkCSF}  onChange={this.handleChange}/>
                        &nbsp;&nbsp;Cambiar servicios en facturación desde {fechaCSF}
                      </h3>
                    </Form.Field>
                  </div> */}
                </div>
              </div>
              <hr></hr>
              <hr></hr>

              <div className="ui two column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Tarifa actual
                      </label>
                      <ListaTarA styles={this.props.styles} list={list7} handleChange={this.handleChange} />
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Tarifa nueva
                      </label>
                      <ListaTarN styles={this.props.styles} list={list7} handleChange={this.handleChange} />
                    </Form.Field>
                  </div>
                </div>
              </div>

              <div className="ui two column stackable grid">
                <div className="row container">
                  {/* <div className="column" style={{width: '100%'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Tarifa
                      </label>
                      <ListaTar styles={this.props.styles} list={list7} handleChange={this.handleChange} />
                    </Form.Field>
                  </div> */}

                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Servicio actual
                      </label>
                      <ListaServA styles={this.props.styles} list={list6A} handleChange={this.handleChange} />
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Servicio nuevo
                      </label>
                      <ListaServN styles={this.props.styles} list={list6N} handleChange={this.handleChange} />
                    </Form.Field>
                  </div>
                </div>
              </div>
              <hr></hr>
              <hr></hr>
              <div className="ui two column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Departamento
                      </label>
                      <ListaDe list={this.props.list1} styles={this.props.styles}
                        handleLista={this.props.handleLista} codigoCiudadUA={this.props.codigoCiudadUA}
                        codigoDptoUA={this.props.codigoDptoUA}/>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Ciudad
                      </label>
                      <ListaCi list={listCiu} styles={this.props.styles}
                        handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                        codigoCiudadUA={this.props.codigoCiudadUA}/>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Zona
                      </label>
                      <ListaZo list={listZon} styles={this.props.styles}
                        handleLista2={this.props.handleLista2} argsSelDpto={this.props.argsSelDpto}/>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '50%'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Barrio
                      </label>
                      <ListaBa list={listBar} styles={this.props.styles}
                        handleLista3={this.props.handleLista3} argsSelDpto={this.props.argsSelDpto}/>
                    </Form.Field>
                  </div>
                </div>
              </div>

              <hr></hr>
              <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                Estrato
              </p>
              <Form.Field>
                <ListaES styles={this.props.styles} list={this.props.list3} handleChange={this.handleChange} />
              </Form.Field>
              <hr></hr>

              <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                Total Clientes:&nbsp;
                {totCli}
              </p>

              <div className="ui three column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '34%'}}>
                    <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev)} fluid>
                      VER CLIENTES
                    </Button>
                  </div>
                  <div className="column" style={{width: '33%'}}>
                    <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev)} fluid>
                      ARCHIVO EXCEL
                    </Button>
                  </div>
                  <div className="column" style={{width: '33%'}}>
                    <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                  </div>
                </div>
              </div>
              <hr></hr>

              <div style={{height: '40em', overflow: 'auto'}}>
                  {/* <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev)} fluid>
                            VER CLIENTES
                        </Button>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                      </div>
                    </div>
                  </div> */}
                  {/* <hr></hr> */}
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th rowSpan='2'  className=''>Contrato</th>
                        <th colSpan='2' className='center aligned'>{argsDocum.codigoTarifaA} {descrTarifaA} - {descrServicioA} ={">"}</th>
                        <th colSpan='2' className='center aligned'>{argsDocum.codigoTarifaN} {descrTarifaN} - {descrServicioN}</th>
                      </tr>
                      <tr className=''>
                        <th className='right aligned'>$ Total</th>
                        <th className='right aligned'>$ Antes Imptos</th>
                        <th className='right aligned'>$ Total</th>
                        <th className='right aligned'>$ Antes Imptos</th>
                      </tr>
                    </thead>
                    <ListaAT list={listaCliCS}/>
                  </table>
                </div>
              </div>
              {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }

            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  // graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: argsBuscarCL}}}),
  graphql(queries.query.allClientesRtes, {name:'allClientesRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: "XXXYYYZZZ"}}]`}}}}),

  graphql(queries.query.allTarifa, {name:'allTarifa', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.editClienteUpdDocMany, {name:'editClienteUpdDocMany'}),
  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),

  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
  )(ProcCS2)
